import {
  IDENTITY_LINK_EVENT_NAME,
  IdentityKind,
  type IdentityLinkEventData,
  type TrackRequestBody,
} from '@getjust/api-schema/analytics';

import { analyticsAPI } from '$src/http';

/**
 * Emits the recognition event that links the anonymous visitor id to the JUST
 * customer id, at the moment the checkout form recognises a signed-in shopper.
 *
 * It goes through `POST /track`, whose consumer writes it to our own event
 * landing. PostHog never receives it: the link it would represent is the very
 * person merge we are replacing, and that merge is not reproducible outside
 * PostHog.
 *
 * Fire-and-forget: analytics must never break the checkout, so the request is
 * not awaited and every failure is swallowed.
 */
export function trackIdentityLink({
  shopId,
  visitorId,
  customerId,
}: {
  shopId: string;
  visitorId: string;
  customerId: string;
}): void {
  const data: IdentityLinkEventData = {
    identityKind: IdentityKind.JUST_CUSTOMER_ID,
    identityValue: customerId,
    source: 'checkout_sign_in',
  };

  const body: TrackRequestBody = {
    shopId,
    userId: visitorId,
    timestamp: Date.now(),
    event: { name: IDENTITY_LINK_EVENT_NAME, data },
  };

  void analyticsAPI.post('/track', body).catch(() => {
    // Silently ignored - no retries.
  });
}
